import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getErrorMessage } from "../../../utils/GeneralUtils";
import SharedRecordAPI from "../../api/SharedRecordAPI";
import { ShareAuthType } from "../../../components/PageView/ShareScreenDrawer/ShareScreenDrawer";

interface Props {
  viewID: string;
  authentication: ShareAuthType;
  password: string;
  recordID: string;
  recordModule: string;
  subviews: string[];
  onSuccess: () => void;
  onError: (err: string) => void;
}

export default function useCreateSharedRecordPage() {
  const client = useQueryClient();

  const createSharedRecordPage = useMutation({
    mutationFn: ({
      viewID,
      authentication,
      password,
      recordID,
      recordModule,
      subviews,
    }: Props) => {
      return SharedRecordAPI.CreateSharedRecordPage({
        RecordID: recordID,
        ViewID: viewID,
        Authentication: authentication,
        Password: password,
        ModuleAPIName: recordModule,
        SubViews: subviews,
      }).then((data) => data.data.data);
    },
    onSuccess: (data, { onSuccess, viewID, recordID }) => {
      const recordPage = data || {};

      if (recordPage) {
        client.setQueryData(["userSharedRecordPage", recordID, viewID], {
          ...recordPage,
          exists: true,
        });
      }

      onSuccess();
    },
    onError: (e, { onError }) => {
      console.log(e);
      onError(getErrorMessage(e));
    },
  });

  return {
    createSharedRecordPage: createSharedRecordPage.mutate,
    creatingSharedRecordPageLoading: createSharedRecordPage.isPending,
  };
}
